import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry Error Tracking
import { initSentry } from "./lib/sentry";
import { AppErrorBoundary } from "./components/error/ErrorBoundary";

initSentry();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
);
